import React from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { Button, Stack, Typography } from '@mui/material';

interface Props {
  onAdd: VoidFunction;
}

export const TradeInEmptyState = ({ onAdd }: Props) => (
  <Stack gap="1rem">
    <Typography variant="h6" component="span">
      Trade-In
    </Typography>

    <Stack
      gap="0.5rem"
      direction="row"
      alignItems="center"
      sx={{ p: '0.75rem 1rem', borderRadius: 1, bgcolor: grey[100] }}
    >
      <Typography variant="subtitle2" color="text.secondary" component="span">
        No trade-in added
      </Typography>

      <Button variant="text" size="small" startIcon={<AddIcon fontSize="small" />} onClick={onAdd}>
        Add
      </Button>
    </Stack>
  </Stack>
);
